import { media } from 'ui';
import styled, { css } from 'styled-components';
import { keys } from 'lodash';
import { useField } from 'formik';
import { KoobInputSegmented } from '@koob/ui';

export const ErrorText = styled.div`
  color: ${({ theme }) => theme.error};
  padding: ${({ theme }) => theme.spacing(0.5)} 0;
`;

export const SegmentedControlField = ({ options, disabled, ...props }) => {
  const [field, meta, { setValue }] = useField(props.name);
  return (
    <KoobInputSegmented
      options={options}
      value={field.value}
      disabled={disabled}
      onChange={setValue}
      error={meta.touched ? meta.error : undefined}
    />
  );
};

export const Container = styled.div`
  background-color: transparent;
  display: block;
  padding: ${({ theme }) => theme.spacing()};
  margin: 0 auto;

  ${media.tablet`
    padding: ${({ theme }) => theme.spacing(2)};
  `};

  ${media.desktop`
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
    padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) =>
      theme.spacing(4)};
    ${props =>
      props.reservation &&
      css`
        max-width: 100%;
        min-height: 700px;
      `}
  `}
  > * {
    margin-bottom: 0;

    + * {
      margin-top: ${({ theme }) => theme.spacing()};
      margin-bottom: ${({ theme }) => theme.spacing(2)};
    }
  }
`;

export const SplitContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;

  ${props =>
    props.reservation &&
    css`
      margin-top: 30px;
    `}

  ${props =>
    props.reverse &&
    css`
      flex-direction: column;
    `}
  ${media.medium`
    flex-direction: row;
    justify-content: space-between;
  `}
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  height: 52px;
`;

export const LeftContainer = styled.div`
  max-width: 800px;
  width: 100%;
  text-align: left;
  margin-top: ${({ theme }) => theme.spacing(2)};

  > * + * {
    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }

  ${props =>
    props.reservation &&
    css`
      max-width: unset;
      padding-left: 0;
      ${media.medium`
      padding-left:10%;
    `}
    `}

  ${media.medium`
  text-align: left;
  margin-top:0;

    ${Buttons} {
      display: flex;
      justify-content: flex-end;
    }
  `}
`;

export const RightContainer = styled.div`
  max-width: 100%;
  width: 100%;
  margin-top: 0;
  ${media.medium`
    margin-left: ${({ theme }) => theme.spacing(2)};
    margin-top: ${({ theme }) => theme.spacing(-4)};
    max-width: 300px;

    ${props =>
      props.reservation &&
      css`
        max-width: 400px;
        margin-top: -15px;
      `}
    ${props =>
      props.reservationExp &&
      css`
        margin-top: 0 !important;
        max-width: 500px;
      `};
  `};
`;

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${({ theme }) => theme.spacing(-1)};
  margin-left: ${({ theme }) => theme.spacing(-1)};
  grid-template-columns: repeat(1, 1fr);

  ${media.tablet`
    width: 100%;
    grid-template-columns: repeat(4, 1fr);
  `}
`;

export const Cell = styled.div`
  flex: 1;
  padding-top: ${({ theme }) => theme.spacing()};
  padding-left: ${({ theme }) => theme.spacing()};
  min-width: 0;

  ${props =>
    props.sizes &&
    css`
      flex: 0 0 ${Math.floor(props.sizes.default * 10000) / 100}%;

      ${keys(props.sizes)
        .filter(key => key !== 'default')
        .map(
          breakpoint => css`
            ${media[breakpoint]`flex: 0 0 ${
              Math.floor(props.sizes[breakpoint] * 10000) / 100
            }%`};
          `,
        )};
    `};
`;

export const Text = styled.span`
  color: #6c6c6c;
  font-size: 1rem !important;

  > div > ul > li {
    font-size: 1rem !important;
    margin-left: -19px;
  }

  > div > p {
    font-size: 1rem !important;
  }

  > div > h2 {
    font-size: 1.925rem !important;
    margin-top: 35px;
    color: #000 !important;
  }
`;
